class MobileNav {
	constructor() {
		this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
		this.handleSubMenuExpandClick = this.handleSubMenuExpandClick.bind(this);
		this.toggleUtilityMenus = this.toggleUtilityMenus.bind(this);
		this.closeMenus = this.closeMenus.bind(this);
	}

	init() {
		$("[data-toggle-menu]").on("click", this.toggleMobileMenu);
		$(".main-header__right button").on("click", this.toggleUtilityMenus);
		$(".main-header__desktop-close-menu").on("click", this.closeMenus);
		$(".has-children").each((index, navItem) => {
			$(navItem).on("click", this.handleSubMenuExpandClick);
		});
		this.vhMobileHeight();
	}

	// Resize vh for mobile menu height
	vhMobileHeight() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	}

	// Toggle mobile menu
	toggleMobileMenu(event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
		event.preventDefault();
		const target = event.currentTarget;
		if ($("body").is(".open-nav")) {
			$("body").removeClass("open-nav");
			$(target).attr("aria-expanded", "false");
			$(target).attr("title", "Open main menu");
			$(target).removeClass("menu--close");
			this.vhMobileHeight();
		} else {
			$("body").addClass("open-nav");
			$(target).attr("aria-expanded", "true");
			$(target).attr("title", "Close main menu");
			$(target).addClass("menu--close");
			if ($("body").is(".open-global")) {
				$("body").removeClass("open-global");
				$(".main-header__global-btn").removeClass("global-btn-active");
			}
		}
	}

	// Toggle Submenus (Desktop and Mobile)
	handleSubMenuExpandClick(
		event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>,
	) {
		event.stopPropagation();
		const currentTarget = $(event.currentTarget);
		const submenu = currentTarget.children(".main-header__menu-links-submenu, .second-submenu");

		// 他のサブメニューを閉じる処理
		const scope = currentTarget.hasClass("submenu-child")
			? ".main-header__menu-links-submenu" // サブメニュー内
			: ".main-header__menu-links"; // メインメニュー直下

		currentTarget
			.closest(scope)
			.find(".has-children")
			.not(currentTarget)
			.removeClass("active")
			.children(".main-header__menu-links-submenu, .second-submenu")
			.slideUp(400);

		// 現在のアイテムをトグル
		currentTarget.toggleClass("active");

		if (submenu.length > 0) {
			submenu.slideToggle(400);
			if ($("body").is(".open-search")) {
				$("body").removeClass("open-search");
			}
			if ($("body").is(".open-global")) {
				$("body").removeClass("open-global");
			}
		}
	}

	// Toggle Utility Menus (Search and Global)
	toggleUtilityMenus(event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
		event.preventDefault();
		const target = $(event.target);

		if (target.is(".main-header__search-btn")) {
			if ($("body").is(".open-search")) {
				$("body").removeClass("open-search");
			} else {
				$("body").addClass("open-search");
				$("body").removeClass("open-global");
				setTimeout(() => {
					$(".mf_finder_searchBox_query_input").focus();
				}, 100);
			}
		}
		if (target.is(".main-header__global-btn")) {
			if ($("body").is(".open-global")) {
				target.removeClass("global-btn-active");
				$("body").removeClass("open-global");
			} else {
				target.addClass("global-btn-active");
				$("body").addClass("open-global");
				$("body").removeClass("open-search");

				if ($("body").is(".open-nav")) {
					$("body").removeClass("open-nav");
					$(".main-header__mobile-icon").removeClass("menu--close");
				}
			}
		}
		$(".main-header__menu-links-submenu").slideUp(400);
		$(".has-children").removeClass("active");
	}

	// Close menu button
	closeMenus(event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
		event.preventDefault();
		event.stopPropagation();
		$("body").removeClass("open-search");
		$("body").removeClass("open-global");
		$(".main-header__menu-links-submenu").slideUp(400);
		$(".has-children").removeClass("active");
	}

	// Reset open menu classes on resize
	removeOpenMenuClasses() {
		if (typeof window !== "undefined" && window.matchMedia("(min-width: 991px)").matches) {
			$("body").removeClass("open-search");
			$("body").removeClass("open-global");
			$("body").removeClass("open-nav");
			$(".main-header__global-btn").removeClass("global-btn-active");
			$(".main-header__mobile-icon").removeClass("menu--close");
		}
	}
}

export default new MobileNav();
